import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box } from "@mui/material";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box textAlign="center" mt={10}>

    </Box>
  );
};

export default Home;
